import server from '../api/server'

export const searchDestinationsAndHotel = (text) => {
  return server.get('/search_destinations_and_hotels', { params: { q: text } })
}
